<template>
  <v-row class="widget-container m-r-0 m-l-0" :style="borderStyle">
    <v-col cols="5" class="padding0">
      <div class="text-right">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-progress-circular
                :rotate="-90"
                :size="80"
                :width="5"
                :value="loading ? 0 : percent"
                :color="color"
              >
                {{ loading ? '...' : `${percent}%` }}
              </v-progress-circular>
            </div>
          </template>
          <span>
            <div>{{ tooltip }}</div>
          </span>
        </v-tooltip>
      </div>
    </v-col>
    <v-col cols="7" class="padding0">
      <div v-if="loading" class="text-running">...</div>
      <div v-else>
        <animated-number
          class="text-running"
          :value="value"
          :formatValue="formatToPrice"
          :duration="1500"
        />
      </div>
      <div class="description weight-500" v-html="title"></div>
    </v-col>
  </v-row>
</template>

<script>
import AnimatedNumber from 'animated-number-vue'
export default {
  components: {
    AnimatedNumber
  },
  props: ['color', 'icon', 'title', 'value', 'percent', 'tooltip', 'loading'],
  computed: {
    borderStyle() {
      return {
        alignItems: 'center !important',
        borderRadius: '4px'
      }
    },
    backgroundStyle() {
      return {
        background: `${this.color} !important`
      }
    }
  },
  methods: {
    formatToPrice(value) {
      const nf = new Intl.NumberFormat('en-US') // commas, US format
      return nf.format(value.toFixed(0)) // hide fractions
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-container {
  justify-content: center;
  align-items: center;
  font-size: 18px;
  margin: 10px 0;

  .v-progress-circular {
    // width: 80px;
    // height: 80px;
    // border-radius: 50%;
    // text-align: center;
    // line-height: 50px;
    // vertical-align: middle;
    margin-right: 25px;
    // font-size: 40px;
    // color: white !important;

    ::v-deep .v-progress-circular__info {
      font-size: 28px;
      color: #555555;
    }
  }

  .text-running {
    color: #555555;
    font-weight: 800;
    font-size: 50px;
  }

  .description {
    margin-top: -10px;
  }
}
</style>
